import useMediaQuery from './useMediaQuery';
import { VIEW_MODE_BREAKPOINTS } from '../constants';

// The narrowest phones (below NARROW_MOBILE_MAX_WIDTH): a leaderboard row has
// room for two data columns and no more, whatever the round's state.
// leaderboard_v2_mobile.sass keys its narrow rules on the same width.
const useNarrowMobile = () =>
  useMediaQuery(`(max-width: ${VIEW_MODE_BREAKPOINTS.NARROW_MOBILE_MAX_WIDTH}px)`);

export default useNarrowMobile;
